"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _validators = _interopRequireDefault(require("./validators"));
var _file = require("./file");
var _helpers = require("./helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var presence = (0, _helpers.memoize)(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    message = _ref.message,
    msg = _ref.msg,
    ifCond = _ref["if"],
    unless = _ref.unless;
  msg = msg || message;
  return (0, _helpers.prepare)(ifCond, unless, false, function (value) {
    if (typeof value === 'string' ? !value.trim() : (0, _file.isFileList)(value) && !isNaN(value.length) ? !value.length : !value) {
      return _validators["default"].formatMessage((0, _helpers.prepareMsg)(msg, 'presence'));
    }
  });
});
var _default = presence;
exports["default"] = _default;